import styled from 'styled-components'

interface ImageLinkProps {
    $position: string // 定义 position 属性类型
}

export const FooterWrapper = styled.div`
    height: 172px;
    background-color: #f2f2f2;
    color: #666;
    border-top: 1px solid #d3d3d3;
    .content {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
`

export const FooterLift = styled.div`
    padding-top: 15px;
    line-height: 24px;
    .link {
        a {
            color: #999;
        }

        .line {
            margin: 0 10px;
            color: #999;
        }
    }

    .copyright {
        span {
            margin-right: 15px;
        }
    }
`

export const FooterRight = styled.ul`
    display: flex;

    .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 40px;

        .title {
            margin-top: 8px;
        }
    }
`

// 创建一个新的组件来接收背景位置
export const ImageLink = styled.a<ImageLinkProps>`
    display: block;
    width: 50px;
    height: 45px;
    background-image: url(${require('@/assets/img/sprite_footer_02.png')});
    background-size: 110px 450px;
    background-position: ${props => props.$position}; /* 根据传入的 position 属性设置背景位置 */
    transition: opacity 0.3s;

    &:hover {
        opacity: 0.8;
    }
`
